export const hoveredParcel = (state = {}, action) => {
  switch (action.type) {
    case 'SET_HOVERED_PARCEL': {
      const { parcel, displayParcel } = action.payload;
      return { parcel, displayParcel };
    }
    case 'CLEAR_HOVERED_PARCEL':
      return {};
    default:
      return state;
  }
};
